
/**
 * Utility functions for formatting trip data
 */

// Format booking duration (could be string "HH:MM:SS" or number)
export const formatDuration = (duration: string | number): string => {
  if (typeof duration === 'string') {
    // If it's in format "HH:MM:SS", extract hours
    const match = duration.match(/^(\d+):/);
    return match ? `${match[1]} hours` : `${duration}`;
  }
  return `${duration} hours`;
};

// Format price (could be number or string with currency format)
export const formatPrice = (price: number | string): string => {
  if (typeof price === 'string') {
    return price;
  }
  return price.toString();
};

// Determine if trip is completed based on status and claimed_by
export const isTripCompleted = (status?: string, claimed_by?: string | null): boolean => {
  return status === "complete" || claimed_by === "completed";
};

// Get location name from address or community event
export const getLocationName = (
  to_address?: any, 
  community_event?: any,
  defaultLocation: string = "Las Vegas"
): string => {
  return to_address?.locality?.name || 
         community_event?.address?.locality?.name || 
         defaultLocation;
};

// Get event name from community event or default
export const getEventName = (community_event?: any, defaultName: string = "Event"): string => {
  return community_event?.name || defaultName;
};

// Determine if trip is one-way or round trip
export const getTripType = (is_round_trip?: boolean): string => {
  return is_round_trip ? "Round Trip" : "One Way";
};
